<template>
   
   <!-- <div class="modal-dialog">
      <div class="modal-content">

         <div class="modal-header justify-content-end" style="background-color: #00A0C1; height:50px;">
            <div>
               <button ref="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetForm()"></button>
            </div>
         </div>
         
         <div class="modal-body"> -->

            <div class="row text-center justify-content-center">
               <h1 class="modal-title"><strong> Subcategory </strong></h1>
            </div>

            <hr />

            <form class="row mx-4 g-0" style="gap: 1rem">

               <div class="form-floating">
                  <select class="form-select" id="category" v-model.trim="subcategory.category" @blur="v$.subcategory.category.$touch"
                     @change="v$.subcategory.category.$touch" disabled>
                     <option selected disabled value>Please choose...</option>
                     <option v-for="category in categories" :value="category.id" :key="category.id">{{category.display_name}}</option>
                  </select>
                  <label for="category" class="text-muted">Category</label>
                  <span class="form-text text-danger" v-if="v$.subcategory.category.$dirty && subcategory.category==''">
                     Category is required.
                  </span>
               </div>

               <div class="form-floating">
                  <input type="text" id="subcategoryName" v-model.trim="subcategory.name" @blur="v$.subcategory.name.$touch"
                     class="form-control" placeholder="Subcategory Name" :disabled="isEditing" @input="isUnique.name=true"/>
                  <label for="subcategoryName" class="text-muted">Subcategory Name</label>
                  <div class="pt-1">
                     <span class="form-text" :class="{'text-danger' : v$.subcategory.name.alphaNumericUnderscore.$invalid, 
                        'text-muted' : !v$.subcategory.name.alphaNumericUnderscore.$invalid}">
                        Minimum of 3 characters long. Must contain letters, numbers and underscores only.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="v$.subcategory.name.required.$invalid && v$.subcategory.name.$dirty">
                        Subcategory Name is required.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="!isUnique.name">
                        Subcategory Name already exists.
                     </span>
                  </div>
                  
               </div>
               
               <div class="form-floating">
                  <input type="text" id="displayName" v-model.trim="subcategory.displayName" @blur="v$.subcategory.displayName.$touch"
                     class="form-control" placeholder="Display Name" @input="isUnique.displayName=true"/>
                  <label for="displayName" class="text-muted">Display Name</label>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="v$.subcategory.displayName.required.$invalid && v$.subcategory.displayName.$dirty">
                        Display Name is required.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="!isUnique.displayName">
                        Display Name already exists.
                     </span>
                  </div>
                  
               </div>
               
               <div class="pt-2 pb-2 justify-content-center d-flex" style="gap:0.5rem">
                  <button v-if="!isEditing" type="button" class="btn btn-outline-warning" @click="resetForm()">Clear fields</button>
                  <button v-if="!isEditing" type="button" class="btn btn-info text-light"
                     @click="createSubcategory()" :disabled="disableFormButton()"> Create </button>
                  <button v-if="isEditing" type="button" class="btn btn-info text-light"
                     @click="updateSubcategory(subcategory.id)" :disabled="disableFormButton()"> Update </button>
               </div>
            </form>

         <!-- </div>
      </div>
   </div> -->

   <ConfirmModal
      v-model="showConfirmModal"
      :title="confirmModalTitle"
      :message="confirmModalMessage"
      @confirm="onConfirmAction"
   />

</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

const alphaNumericUnderscore = helpers.regex(/^[a-zA-Z0-9][\w]+[a-zA-Z0-9]$/) //matches alphaNumeric and underscores

export default({

   setup () {
      return { v$: useVuelidate() }
   },

   data(){
      return{
         categories: [],
         subcategories: [],
         subcategory: {
            id: '',
            name: '',
            displayName: '',
            category: '',
         },
         isEditing: false,
         isUnique: {
            name: true,
            displayName: true,
         },
         showConfirmModal: false,
         confirmModalTitle: '',
         confirmModalMessage: '',
         pendingDeleteId: null,
      }
   },

   validations() {
      return {
         subcategory: {
            name: { required, alphaNumericUnderscore },
            displayName: { required },
            category: { required },
         },
      }
   },

   methods: {

      isCreate(categoryId, groupId){
         this.isEditing = false
         this.getCategoriesList(groupId)
         this.addSubcategory(categoryId)
      },

      isEdit(id, groupId){
         this.isEditing = true
         this.getCategoriesList(groupId)
         this.getSubcategory(id)
      },

      isDelete(id){
         this.deleteSubcategory(id)
      },

      async getCategoriesList(groupId){

         await this.$axios.get("/categories?groupId="+groupId)
         .then((response) => {
            this.categories = response.data.categories
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      async getSubcategory(id) {

         await this.$axios.get("/subcategories/"+id)
         .then((response) => {
            this.subcategory.id = response.data.subcategory.id
            this.subcategory.name = response.data.subcategory.name
            this.subcategory.displayName = response.data.subcategory.display_name
            this.subcategory.category = response.data.subcategory.category_id
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })

      },

      resetForm() {
         this.v$.$reset()
         this.subcategory.id = ""
         this.subcategory.name = ""
         this.subcategory.displayName = ""
         this.isEditing = false
         this.isUnique.name = true
         this.isUnique.displayName = true
      },

      disableFormButton() {
         if (this.v$.$error || this.v$.$invalid){
            return true
         }

         return false
      },

      async addSubcategory(categoryid){

         await this.$axios.get("/categories/"+categoryid)
         .then((response) => {
           this.subcategory.category  = response.data.category.id
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      async createSubcategory() {

         let subcategory = {
            name : this.subcategory.name,
            display_name : this.subcategory.displayName,
            category_id : this.subcategory.category,
         }

        
         await this.$axios.post("/subcategories",subcategory)
         .then((response) => {

            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$refs.closeModal.click();
               this.resetForm();
               
               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.checkError(error)
         })

      },

      async updateSubcategory(id) {

         let subcategory = {
            // name : this.subcategory.name,
            display_name : this.subcategory.displayName,
            category_id : this.subcategory.category,
         }

         await this.$axios.put("/subcategories/"+id, subcategory)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$refs.closeModal.click();
               this.resetForm();
               
               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.checkError(error)
         })

      },

      async deleteSubcategory(id) {
         this.pendingDeleteId = id;
         this.confirmModalTitle = 'Delete Subcategory';
         this.confirmModalMessage = 'Do you want to delete this subcategory?';
         this.showConfirmModal = true;
      },

      async onConfirmAction() {
         const id = this.pendingDeleteId;
         this.pendingDeleteId = null;
         if (!id) return;
         await this.$axios.delete("/subcategories/"+id)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      checkError(error) {
         if(error.response.data.message == "Subcategory Name already exists."){
            this.isUnique.name = false
         } else if(error.response.data.message == "Display Name already exists."){
            this.isUnique.displayName = false
         } else {
            this.$toast.error(error.response.data.message)
         }
      },
   
   },

})
</script>

<style scoped>

.btn {
   width: 7rem;
}

</style>